// extracted by mini-css-extract-plugin
module.exports = {"recommendationsWrapper":"rH","recommendation":"rI"};